export type ISetImageUploadButtonElms = (
  input: HTMLInputElement | JQuery<HTMLInputElement>,
  imageJSON: {
    name: string;
    downloadUrl: string;
    height: number;
    width: number;
  }
) => void;

export function _setImageUploadButtonElms(
  input: HTMLInputElement | JQuery<HTMLInputElement>,
  imageJSON: {
    name: string;
    downloadUrl: string;
    height: number;
    width: number;
  }
): void {
  const $input = $(input);
  const fileUploadInputName = $input.attr('name');
  const $formGroup = $input.closest('.form-group');
  const $fileUploadedHolder = $formGroup.find('.file-uploaded-holder');
  const $oldFileInput = $formGroup.find(`input[name="${fileUploadInputName}_old"]`);

  // /Elements to set after upload
  const $fileNameSpan = $formGroup.find('span.file-name');
  const $viewImageButton = $formGroup.find('button.image-trigger');
  const $cropImageButton = $formGroup.find('button.crop-image-trigger');
  const $deleteImageButton = $formGroup.find('button.reset-file-upload');

  // Image components
  const { name, downloadUrl, height, width } = imageJSON;
  const trimmedName = name.length > 20 ? `${name.substring(0, 20)}...` : false;
  let $fileNameSpanA = $fileNameSpan.find('a');

  if (!$fileNameSpanA.length) {
    $fileNameSpan.append('<a href="" target="_blank">');
    $fileNameSpanA = $fileNameSpan.find('a');
  }

  // If we have all we need, set the new elements
  // Place the file in the _old input to act as if the fiel had already existed, so it will be uploaded again on submit
  ($oldFileInput as any).val(($input[0] as any).files[0]);
  $fileNameSpan
    .data({
      'file-name': name,
    })
    .attr({
      'data-file-name': name,
    })
    .removeClass('overwrite-file');
  $fileNameSpanA
    .attr({
      'data-original-title': name,
      href: downloadUrl,
    })
    .data('original-title', name);

  $fileNameSpanA.html(trimmedName || name);

  $viewImageButton
    .data({
      href: downloadUrl,
      'image-height': height,
      'image-width': width,
      'modal-title': name,
    })
    .attr({
      'data-href': downloadUrl,
      'data-image-height': height,
      'data-image-width': width,
      'data-modal-title': name,
    });
  $cropImageButton
    .data({
      href: downloadUrl,
      'image-height': height,
      'image-width': width,
      'modal-title': name,
    })
    .attr({
      'data-href': downloadUrl,
      'data-image-height': height,
      'data-image-width': width,
      'data-modal-title': name,
    });

  $deleteImageButton
    .data({
      'file-name': name,
    })
    .attr({
      'data-file-name': name,
    });
  // Show image buttons block
  $fileUploadedHolder.removeClass('hide').attr('aria-hidden', 'false');
}
